/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

type ExtensionVersionResponse = {
	detail: {
		version: string;
		name: string;
		browser: string;
	};
};

export enum ActionTypes {
	SetRequirements = 'setRequirements',
	ExtensionChecked = 'extensionChecked',
	CheckTimedOut = 'checkTimedOut',
	ExtensionUninstalled = 'extensionUninstalled',
	ExtensionUpdated = 'extensionUpdated',
}

export type Action =
	| { type: ActionTypes.SetRequirements; data: { minVersion: string } }
	| { type: ActionTypes.ExtensionChecked; data: ExtensionVersionResponse }
	| { type: ActionTypes.CheckTimedOut }
	| { type: ActionTypes.ExtensionUninstalled }
	| { type: ActionTypes.ExtensionUpdated };

export const setRequirements = (minVersion: string): Action => ({ type: ActionTypes.SetRequirements, data: { minVersion } });

export const extensionChecked = (data: ExtensionVersionResponse): Action => ({ type: ActionTypes.ExtensionChecked, data });

export const checkTimedOut = (): Action => ({ type: ActionTypes.CheckTimedOut });

export const extensionUninstalled = (): Action => ({ type: ActionTypes.ExtensionUninstalled });

export const extensionUpdated = (): Action => ({ type: ActionTypes.ExtensionUpdated });
